/**
 * A reusable empty function that performs no operations.
 * Use this function to avoid unnecessary memory allocation
 * when an empty function is required, such as in event handlers.
 */

export const emptyFunction = (): any => {
    // no operation performed
};
